import React, { useEffect, useState, useRef } from "react";
import { Box, DialogContent, Grid, CircularProgress } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import {
  IconButtonComponent,
  RadioButtonGroup,
  TextEditior,
} from "../../../atom";
import { getSourcePath, getText } from "../../../../core/Constant";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { useParams } from "react-router-dom";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import DropDownComponent from "../../../atom/Inputs/DropDown";

const initObj = {
  textValue: "",
  isChecked: false,
  isTextValid: false,
  isTextError: false,
};

const AdminQuestionsEdit = ({
  onClose = () => { },
  questionDetails = {},
}) => {
  const [inputCount, setInputCount] = useState(1);
  const [inputValues, setInputValues] = useState([initObj]);
  const param = useParams();

  const [qId, setQid] = useState(-1);
  const [questionId, setQuestionId] = useState(-1);

  const [question, setQuestion] = useState("");
  const [qisValid, setIsQValid] = useState(false);
  const [qIsError, setIsQError] = useState(false);
  const dispatch = useDispatch();

  const [isValidAns, setIsValidAns] = useState(false);

  const [reason, setReason] = useState("");
  const [reasonValid, setIsReasonValid] = useState(false);
  const [reasonIsError, setIsReasonError] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState(false);

  const [isCorrectAnsValid, setIsCorrectAnsValid] = useState(false);
  const [correctAnsError, setCorrectAnsError] = useState(false);
  const [existingImages, setExistingImages] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const deletedImageIdsRef = useRef([]);
  const existingImagesRef = useRef([]);

  const [subject, setSubject] = useState();
  const [category, setCategory] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(Actions.questions.getSubjectList());
    dispatch(Actions.questions.getCategoryList());
  }, []);

  const categoryList = useSelector((state) =>
    state.questions.get("categoryList")
  );
  const subjectList = useSelector((state) =>
    state.questions.get("subjectList")
  );


  useEffect(() => {
    setQuestionId(questionDetails?.id);
    setQuestion(questionDetails?.question);
    setIsQValid(true);
    setReason(questionDetails?.reason);
    setSubject(questionDetails?.subject_id);
    setCategory(questionDetails?.category_id);
    setIsReasonValid(true);

    // Handle existing images - can be from 'images' array (new) or 'image' field (old)
    let imageArray = [];

    // Check for new format: images array
    if (
      questionDetails?.images &&
      Array.isArray(questionDetails.images) &&
      questionDetails.images.length > 0
    ) {
      imageArray = questionDetails.images.map((img) => ({
        id: img.id,
        src: getSourcePath(img.image_path),
        image_path: img.image_path,
        question_id: img.question_id,
      }));
    }
    // Check for old format: single image field
    else if (questionDetails?.image) {
      if (Array.isArray(questionDetails.image)) {
        // Multiple images in old format
        imageArray = questionDetails.image.map((img) => ({
          id: img?.id || null,
          src: getSourcePath(img?.image_path || img),
          image_path: img?.image_path || img,
          question_id: questionDetails?.id,
        }));
      } else if (questionDetails.image !== null) {
        // Single image in old format
        imageArray = [
          {
            id: questionDetails?.image?.id || null,
            src: getSourcePath(questionDetails.image?.image_path || questionDetails.image),
            image_path: questionDetails.image?.image_path || questionDetails.image,
            question_id: questionDetails?.id,
          },
        ];
      }
    }

    // Reset all image states
    setExistingImages(imageArray);
    existingImagesRef.current = imageArray;
    setDeletedImageIds([]);
    deletedImageIdsRef.current = [];

    let newInputValues = [];
    let answers = _.get(questionDetails, "answers", []);

    // Check if 'answers' is a string (JSON encoded)
    if (typeof answers === "string") {
      try {
        answers = JSON.parse(answers); // Parse it into an array
      } catch (error) {
        console.error("Error parsing answers JSON:", error);
        answers = [];
      }
    }
    answers.forEach((item, index) => {
      newInputValues.push({
        textValue: item?.answer,
        isChecked: item?.is_correct === 1,
        isTextValid: true,
        isTextError: false,
        key: index,
      });
    });
    if (newInputValues.length > 0) {
      setInputValues(newInputValues);
      setIsValidAns(true);
    } else {
      setInputValues([]);
    }
  }, [questionDetails]);

  useEffect(() => {
    const id = param.id;
    setQid(id);
  }, [param]);

  const addInputField = () => {
    setInputCount(inputCount + 1);
    setInputValues([...inputValues, initObj]);
  };

  const removeInputField = (index) => {
    let newInputFields = [...inputValues];
    newInputFields.splice(index, 1);
    setInputValues(newInputFields);
    setInputCount(inputCount - 1);
  };

  const handleInputChange = (index, value) => {
    const updatedValues = [...inputValues];
    const item = updatedValues[index];

    let isValid = value?.length > 0;

    updatedValues[index] = {
      ...item,
      textValue: value,
      isTextValid: value?.length > 0,
      isTextError: false,
    };

    for (const item of updatedValues) {
      isValid = item.isTextValid && isValid;
    }
    setInputValues(updatedValues);
    setIsValidAns(isValid);
  };

  const handleRadioChange = (index, value) => {
    const updatedValues = [...inputValues];

    const item = updatedValues[index];
    const isChecked = item?.isChecked;
    updatedValues[index] = {
      ...item,
      isChecked: !isChecked,
    };
    setInputValues(updatedValues);
  };

  const checkCorrectAnswer = (dataArray) => {
    let ansCount = 0;
    for (var i = 0; i < dataArray.length; i++) {
      if (dataArray[i].isChecked) {
        ansCount++;
      }
    }
    setIsCorrectAnsValid(ansCount > 0);
    setCorrectAnsError(!ansCount > 0);

    setInputValues(
      dataArray.map((item) => {
        if (!item.isTextValid) {
          return { ...item, isTextError: true };
        }
        return item;
      })
    );
    return ansCount > 0;
  };

  const onSubjectChange = (e) => {
    const Selectedvalue = getText(e);
    setSubject(Selectedvalue);
  };

  const onCategoryChange = (e) => {
    const Selectedvalue = getText(e);
    setCategory(Selectedvalue);
  };

  const onChangeQuestion = (text) => {
    setIsQError(false);
    setIsQValid(text.length > 0);
    setQuestion(text);
  };

  const onChangeReason = (text) => {
    setIsReasonError(false);
    setIsReasonValid(text.length > 0);
    setReason(text);
  };

  const onFileUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      setFileError(false);
      // Reset the input value so the same file can be selected again if needed
      e.target.value = "";
    }
  };

  const onRemoveNewImg = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFileError(false);
  };

  const onRemoveExistingImg = (index) => {
    const removedImg = existingImages[index];
    // Track deleted image id
    const deleteIdentifier = removedImg?.id ?? removedImg?.image_path;

    if (deleteIdentifier !== undefined && deleteIdentifier !== null) {
      const updatedIds = [...deletedImageIdsRef.current, deleteIdentifier];
      deletedImageIdsRef.current = updatedIds;
      setDeletedImageIds(updatedIds);
    }

    // Update remaining existing images
    const updatedImages = existingImages.filter((_, i) => i !== index);
    existingImagesRef.current = updatedImages;
    setExistingImages(updatedImages);
  };

  const onUpdateQuestion = () => {
    const isAnsValid = checkCorrectAnswer(inputValues);
    onUpload(isAnsValid);
  };

  const onUpload = async (isCorrectAns) => {
    if (qisValid && reasonValid && isValidAns && isCorrectAns) {
      setLoading(true);
      try {
        const list = inputValues.map((item) => {
          return { answer: item?.textValue, is_correct: item?.isChecked ? 1 : 0 };
        });
        const fd = new FormData();
        fd.append("question_id", questionId);
        fd.append("subject_id", subject);
        fd.append("category_id", category);
        fd.append("question", question);
        fd.append("reason", reason);
        fd.append("answers", JSON.stringify(list));
        deletedImageIdsRef.current.forEach((id) => {
          fd.append("deleted_image_ids[]", id);
        });

        if (files.length > 0) {
          files.forEach((file) => {
            fd.append("images[]", file);
          });
        }
        await dispatch(Actions.questions.editQuestion(fd));
        setFiles([]);
        onClose();
      } catch (error) {
        console.error("Error updating question:", error);
      } finally {
        setLoading(false);
      }
    } else {
      if (!qisValid) setIsQError(true);
      if (!reasonValid) setIsReasonError(true);
      if (!isValidAns) {
        setInputValues(
          inputValues.map((item) =>
            !item.isTextValid ? { ...item, isTextError: true } : item
          )
        );
      }
    }
  };


  return (
    <>

      <form onSubmit={(e) => e.preventDefault()}>
        <DialogContent>
          <Grid container flexDirection={"column"}>
            <Grid item>
              <Box>
                <Grid xs={6} item>
                  <DropDownComponent
                    isShowPlaceholder={true}
                    isShowZero={subjectList.length > 0 ? false : true}
                    initialValue="Select Main subject"
                    radius={"15px"}
                    onchange={onSubjectChange}
                    dropdownLabel="Select Subject"
                    list={subjectList}
                    selectedValue={subject}
                    fixedWidth="100%"
                  />
                </Grid>
                <Grid xs={6} item>
                  <DropDownComponent
                    isShowPlaceholder={true}
                    isShowZero={categoryList.length > 0 ? false : true}
                    initialValue="Select Cluster"
                    radius={"15px"}
                    onchange={onCategoryChange}
                    dropdownLabel="Select Cluster"
                    list={categoryList}
                    selectedValue={category}
                    fixedWidth="100%"
                  />
                </Grid>
                <Box>
                  <TextEditior
                    value={question}
                    isError={qIsError}
                    error="Please add question"
                    label={"Question"}
                    placeholder={"Enter question"}
                    onchange={onChangeQuestion}
                  />
                </Box>

                <Box p={1}>
                  <p
                    style={{
                      color: "#4E657C",
                      fontSize: 16,
                      fontWeight: 600,
                      marginBottom: 10,
                    }}
                  >
                    Images
                  </p>

                  {/* Display existing images */}
                  {existingImages.length > 0 && (
                    <Box sx={{ marginBottom: 2 }}>
                      <p
                        style={{ fontSize: 14, color: "#666", marginBottom: 8 }}
                      >
                        Existing Images
                      </p>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(150px, 1fr))",
                          gap: 2,
                          padding: 1,
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        {existingImages.map((img, index) => (
                          <Box
                            key={`existing-${index}`}
                            sx={{
                              position: "relative",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: 1,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                height: "120px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                borderRadius: "4px",
                                backgroundColor: "#f5f5f5",
                                position: "relative",
                              }}
                            >
                              <img
                                src={img.src}
                                alt={`Existing ${index + 1}`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  width: "auto",
                                  height: "auto",
                                  objectFit: "contain",
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  zIndex: 2,
                                }}
                              >
                                <IconButtonComponent
                                  btnType="deleteIconbtn"
                                  onclick={() => onRemoveExistingImg(index)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}

                  {/* Display newly selected images */}
                  {files.length > 0 && (
                    <Box sx={{ marginBottom: 2 }}>
                      <p
                        style={{ fontSize: 14, color: "#666", marginBottom: 8 }}
                      >
                        New Images to Upload
                      </p>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(150px, 1fr))",
                          gap: 2,
                          padding: 1,
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        {files.map((file, index) => (
                          <Box
                            key={`new-${index}`}
                            sx={{
                              position: "relative",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: 1,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                height: "120px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                overflow: "hidden",
                                borderRadius: "4px",
                                backgroundColor: "#f5f5f5",
                                position: "relative",
                              }}
                            >
                              <img
                                src={URL.createObjectURL(file)}
                                alt={`New ${index + 1}`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  width: "auto",
                                  height: "auto",
                                  objectFit: "contain",
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  zIndex: 2,
                                }}
                              >
                                <IconButtonComponent
                                  btnType="deleteIconbtn"
                                  onclick={() => onRemoveNewImg(index)}
                                />
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                marginTop: 1,
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: 12,
                                  color: "#666",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {file.name}
                              </p>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}

                  {/* File input */}
                  <TextInputComponent
                    onchange={onFileUpload}
                    type={"file"}
                    label={
                      existingImages.length > 0 || files.length > 0
                        ? "Add More Images"
                        : "Upload Images"
                    }
                    inputProps={{ multiple: true, accept: "image/*" }}
                  />

                  {fileError ? (
                    <span style={{ color: "red" }}>
                      Please upload at least one image
                    </span>
                  ) : null}
                </Box>

                <Box className="admin-question-answers-wrap">
                  <p
                    style={{
                      padding: 0,
                      paddingInlineStart: 10,
                      margin: 0,
                      color: "#4E657C",
                      fontSize: 19,
                      fontWeight: 700,
                    }}
                  >
                    Answers
                  </p>
                  {inputValues?.map((item, index) => {
                    return (
                      <Box
                        className="admin-question-inner-content"
                        key={index + "new_Ans"}
                      >
                        <Box p={1}>
                          <IconButtonComponent
                            onclick={() => removeInputField(index)}
                            btnType={"deleteIconbtn"}
                          />
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                          <TextInputComponent
                            key={index}
                            onchange={(e) =>
                              handleInputChange(index, getText(e))
                            }
                            placeholder="Enter answer"
                            value={item?.textValue}
                            isError={item?.isTextError}
                            error="Please add value"
                          />
                        </Box>
                        <Box sx={{ width: "fit-content" }}>
                          <RadioButtonGroup
                            checked={item.isChecked}
                            handleChange={(e) => handleRadioChange(index, e)}
                            key={index}
                            size={"large"}
                          />
                        </Box>
                      </Box>
                    );
                  })}
                  {correctAnsError ? (
                    <span style={{ color: "red" }}>Select correct answer</span>
                  ) : null}

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButtonComponent
                      title="Add Answer"
                      onclick={addInputField}
                      size={"large"}
                      fontsize={"large"}
                      btnType={"addIconbtn"}
                    />
                  </Box>
                </Box>

                <Box>
                  <TextEditior
                    value={reason}
                    isError={reasonIsError}
                    error="Please add reason"
                    label={"Reason"}
                    placeholder={"Add reason"}
                    onchange={onChangeReason}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                columnGap: 1,
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <Box sx={{ width: 150 }}>
                <TextButtonComponet
                  text={loading ? <CircularProgress size={20} style={{ color: 'white' }} /> : "Save"}
                  classStyle="btn btn-primary"
                  onButtonClick={onUpdateQuestion}
                  isDisabled={loading}
                />
              </Box>
              <Box sx={{ width: 150 }}>
                <TextButtonComponet
                  text={"Cancel"}
                  classStyle="btn btn-secondary"
                  onButtonClick={() => onClose()}
                  isDisabled={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </form>
    </>
  );
};

export default AdminQuestionsEdit;
